module.exports = "<template> <span if.bind=value textcontent.bind=value></span> <sio-bic-info value.bind=value></sio-bic-info> </template> ";